import gsap from '../utils/gsap-setup';

const init = () => {
    // Find the element that holds the data-text attribute
    const block = document.querySelector('.m-typing-animation');
    if(!block) return;

    const scalingDiamonContainer = document.querySelector('.a-animated-scaling-diamond');
    const typingSection = block.querySelector('.m-typing-animation__typing-section');
    const typed = block.querySelector('.typed');
    const longFormTyped = block.querySelector('.long-form-typed');
    if (!typingSection || !typed) return;

    const bgColor = typingSection.dataset.bgColor?.trim() || '';
    const textOne = typingSection.dataset.textOne?.trim() || '';

  // The new GSAP variable to use.
  let mm = gsap.matchMedia();

  mm.add(
    {
      isDesktop: `(min-width: 1024px)`,
      isMobile: `(max-width: 759px)`,
      isTablet: `(min-width: 760px) and (max-width: 1023px)`,
      isReduceMotion: "(prefers-reduced-motion: reduce)",
    },
    (context) => {
      let {isDesktop, isMobile, isTablet} = context.conditions;

      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: '#typing-scroll-animation-1',
          pin: true,
          start: "top top",
          end: isMobile ? "+=100%" : "+=200%",
          scrub: 0,
          // markers: true,
          pinSpacing: true,
        }
      });

      // Declare animations initial values upfront
      gsap.set(block, {y: 0, yPercent: 0});

      /**********
       * Typing animation
       **********/
      // Fade in the block and start typing
      timeline.to(block, {
        scrollTrigger: {
          trigger: '.m-typing-animation',
          start: () => {
            if (isMobile) {
              return 'top -40%';
            }
            if (isTablet) {
              return 'top 0%';
            }
            return 'top 90%'; // Default for desktop
          }
        },
        opacity: 1
      });
      timeline.to(typed, {
        text: textOne,
        duration: isMobile ? 40 : 20,
        ease: "none",
        onUpdate: function() {
          // On desktop, hide the diamond and show the background color when typing starts.
          if(isMobile) {
            return;
          }

          if(this.progress() > 0) {
            block.classList.add(bgColor);
            scalingDiamonContainer.style.opacity = 0;
            scalingDiamonContainer.style.display = "none";
          } else {
            scalingDiamonContainer.style.display = "block";
            scalingDiamonContainer.style.opacity = 1;
            block.classList.remove(bgColor);
          }
        }
      }, ">");

      // Begin to show the feature intro section and hide the gem shape section.
      timeline.to('.o-feature-intro', { opacity: 1, duration: 0.1 }, ">");

      // Freeze the text for a moment.
      timeline.to({}, {
        duration: 5,
        onUpdate: function() {
          // On mobile, hide the diamond and show the background color when typing starts.
          if(!isMobile) {
            return;
          }

          if(this.progress() > 0) {
            block.classList.add(bgColor);
            scalingDiamonContainer.style.opacity = 0;
            scalingDiamonContainer.style.display = "none";
          } else {
            scalingDiamonContainer.style.display = "block";
            scalingDiamonContainer.style.opacity = 1;
            block.classList.remove(bgColor);
          }
        }
      }, ">");

      // Show the long form text and begin easing it up next to the typed text.
      timeline.to(longFormTyped, {
        autoAlpha: 1,
        y: -50,
        ease:"power2.in",
        duration: 3
      }, ">");

      // Freeze the text for a moment.
      timeline.to({}, { duration: 1 }, ">");

      /********
       * Curtain animation
       ********/
      if(isDesktop || isTablet) {
        // Moves the pink panel up to reveal the next section.
        timeline.to(block, {
          yPercent: -100,
          ease: "none",
          duration: 40
        }, ">");

        // Animates the pink panel's border radius to create a smooth transition.
        timeline.to(block, {
          borderBottomLeftRadius: "30px",
          borderBottomRightRadius: "30px",
          duration: 0.1 // Let the radius animate in as the panel starts moving
        }, "<");

        // Hold after the panel has moved up to ensure the transition is smooth.
        timeline.to('.o-feature-intro', {
          duration: 5,
        });
      }
    });
};

export default init;
